import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("DocumentoBuscaTO")
export class DocumentoBuscaTO {

  url: string;

  codigoVerificador: string;

  validador: string;

}
